import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ConversationContact } from 'app/clmtlk/shared/model/conversationContacts';
import { Observable } from 'rxjs/Observable';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { BlockUIService } from 'ng-block-ui';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { HelperService } from 'app/common/service/model-helper.service';

@Injectable()
export class AutoCompleteResolver implements Resolve<ConversationContact[]> {

    constructor(private clmtlkService: ClmtlkService,
        private router: Router,
        private blockUIService: BlockUIService,
        private clmtlkSessionService: ClmtlkSessionService,
        private helperService: HelperService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): 
    ConversationContact[] | Observable<ConversationContact[]> | Promise<ConversationContact[]> {

       this.blockUIService.start('main', 'Loading Stream Contact Data... please wait');
       let conversationContactList: ConversationContact[];
       return this.clmtlkService.getContactList().map(
            result => {
                conversationContactList = result;
                return conversationContactList;
            }).catch( error =>
            {
                conversationContactList = null;
                console.error(' Get Stream Contact load failed ' + error);
                return Observable.of([]);
            }).finally(() => {
                this.blockUIService.stop('main');
            });

    }

}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/new-message/shared/autocomplete-resolver.service.ts